import clientConfigManagement from './client-config-management';
import uiManagement from './ui-management';
import domainSetups from '../domain-setups';
import vueSetupManagement from './vue-setup-management';
import viewNavigationManagement from './view-navigation-management';
import userManagement from './user-management';
import lobbyHelperService from '../services/lobby-helper-service';
import casinoService from '../services/casino/casino-service';
import popStateManagement from './pop-state-management';
import soarPayManagement from './soar-pay/soar-pay-management';
import zendeskManagement from './zendesk-management';
import maintenanceManagement from './maintenance-management';
import flutterManagement from './flutter-management';
import sportBettingManagement from './sport-betting-management';
import OptimoveManagement from './optimove-management';
import gameFilterManagement from './game-filter-management';
import realtimeBonusEngineManagement from './realtime-bonus-engine-management';
import funclubManagement from './funclub-management';
import miniGameManagement from './mini-games/mini-game-management';
import guestTabFreshnessManagement from './guest-tab-freshness-management';
import creditsManagement from './credits-management';
import currencyManagement from './currency-management';
import browserHistoryHelper from '../utils/browser-history-helper';
import utils from '../utils/utils';
import model from '../model';
import type { MainModel } from '../types/main-model';

export interface SettableModelModule {
    setModel: (m: MainModel) => void,
}

export interface ManagementModule {
    init: () => void,
}

const settableModelModules: SettableModelModule[] = [
    utils,
    browserHistoryHelper,
    currencyManagement,
    creditsManagement,
];

const managementModules: ManagementModule[] = [
    guestTabFreshnessManagement,
    clientConfigManagement,
    uiManagement,
    domainSetups,
    vueSetupManagement,
    viewNavigationManagement,
    userManagement,
    lobbyHelperService,
    casinoService,
    popStateManagement,
    soarPayManagement,
    zendeskManagement,
    maintenanceManagement,
    flutterManagement,
    sportBettingManagement,
    OptimoveManagement,
    gameFilterManagement,
    realtimeBonusEngineManagement,
    funclubManagement,
    miniGameManagement,
];

export function initManagementModulesAndModelRefs(){
    for(const m of settableModelModules) {
        m.setModel(model);
    }

    for(const m of managementModules) {
        m.init();
    }
}
